// src/screens/MoreScreen.jsx
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import { findUserByCpf, findUserByEmail, findUserByName, findUserByUid, findReferredUsers, addServiceClicks, resetClicks, updateRates, getRates, formatCpf, getAllCanjes, markCanjeProcessed, getVuelosReferidos, markVueloReferidoPagado, isPushSupported, subscribeToPush, buscarValePorCodigo, marcarValeUsado, getAllSolicitudes, broadcastNotificacion, ADMIN_EMAIL } from '../services/authService';
import { toast } from '../components/UI';
import GeneradorImagenesPanel from './admin/GeneradorImagenesPanel';
import VuelosGuyanaAdminPanel from './admin/VuelosGuyanaAdminPanel';
import NuestrosClientesAdminPanel from './admin/NuestrosClientesAdminPanel';
import CotizadorPanel from './admin/CotizadorPanel';
import CotizadorPrecios from './admin/CotizadorPrecios';
import MillasPanel from './admin/MillasPanel';
import { getMostrarHerramientasOcultas } from '../services/cotizadorService';
import { GRUPO_WHATSAPP_URL } from '../config/links';

function AdminPanel({ onClose, initialTab, initialSub }) {
  const [tab, setTab] = useState(initialTab || 'tasa');
  const [rateLow, setRateLow]       = useState('');
  const [rateHigh, setRateHigh]     = useState('');
  const [rateBrlUsd, setRateBrlUsd] = useState('');
  const [rateUsdBrl, setRateUsdBrl] = useState('');
  const [currentRates, setCurrentRates] = useState(null);
  const [searchType, setSearchType] = useState('cpf');
  const [searchVal, setSearchVal]   = useState('');
  const [foundUser, setFoundUser]   = useState(null);
  const [clicksToAdd, setClicksToAdd] = useState('');
  const [loading, setLoading]       = useState(false);
  const [cup, setCup]   = useState('');
  const [usdt, setUsdt] = useState('');
  const [brl, setBrl]   = useState('');
  const [eurRecibidos, setEurRecibidos] = useState('');
  const [tasaEurBrlDia, setTasaEurBrlDia] = useState('');
  const [canjesList, setCanjesList] = useState([]);
  const [canjesLoading, setCanjesLoading] = useState(false);
  const [canjesSubTab, setCanjesSubTab] = useState('recargas');
  const [valeCodigo, setValeCodigo] = useState('');
  const [valeResult, setValeResult] = useState(null);
  const [valeLoading, setValeLoading] = useState(false);
  const [valeMarcando, setValeMarcando] = useState(false);
  const [vuelosReferidosList, setVuelosReferidosList] = useState([]);
  const [vuelosReferidosLoading, setVuelosReferidosLoading] = useState(false);
  const [marcandoPagoId, setMarcandoPagoId] = useState(null);
  const [solicitudesList, setSolicitudesList] = useState([]);
  const [solicitudesLoading, setSolicitudesLoading] = useState(false);
  const [solicitudesFiltro, setSolicitudesFiltro] = useState('todas');
  const [anuncioTitulo, setAnuncioTitulo] = useState('Click Travel Agency');
  const [anuncioMensaje, setAnuncioMensaje] = useState('');
  const [enviandoAnuncio, setEnviandoAnuncio] = useState(false);
  // Referidos Vuelos, Anuncios y Generador de Imágenes están escondidos de la
  // fila de pestañas (no se borran); se reactivan desde Cotizador → Ajustes.
  const [mostrarOcultas, setMostrarOcultas] = useState(false);
  React.useEffect(() => { getMostrarHerramientasOcultas().then(setMostrarOcultas); }, [tab]);

  const tasaCliente = (cup && usdt && brl)
    ? (parseFloat(cup) / parseFloat(usdt)) * parseFloat(brl)
    : null;
  const margen = tasaCliente !== null ? tasaCliente - 100 : null;

  // Calculadora privada Copa: cuántos reales le quedan a Yoedis al convertir
  // los euros que le pagan las ventas de Copa -- no toca ningún precio que
  // vea el cliente, es solo para que él decida si el margen le sigue
  // conviniendo tras el cambio real del banco/casa de cambio del día.
  const realesPorEuros = (eurRecibidos && tasaEurBrlDia)
    ? parseFloat(eurRecibidos) * parseFloat(tasaEurBrlDia)
    : null;

  React.useEffect(() => {
    getRates().then(r => {
      setCurrentRates(r);
      if (r.low     > 0) setRateLow(r.low.toFixed(2));
      if (r.high    > 0) setRateHigh(r.high.toFixed(2));
      if (r.brlToUsd > 0) setRateBrlUsd(r.brlToUsd.toFixed(2));
      if (r.usdToBrl > 0) setRateUsdBrl(r.usdToBrl.toFixed(2));
    });
  }, []);

  const handleSaveRates = async () => {
    const low     = parseFloat(rateLow.replace(',', '.'));
    const high    = parseFloat(rateHigh.replace(',', '.'));
    const brlToUsd = parseFloat(rateBrlUsd.replace(',', '.'));
    const usdToBrl = parseFloat(rateUsdBrl.replace(',', '.'));
    if (!low     || low     <= 0) return toast('Ingresa la tasa para montos menores a 100 BRL.', 'error');
    if (!high    || high    <= 0) return toast('Ingresa la tasa para montos de 100 BRL o más.', 'error');
    if (!brlToUsd || brlToUsd <= 0) return toast('Ingresa la tasa BRL → USD.', 'error');
    if (!usdToBrl || usdToBrl <= 0) return toast('Ingresa la tasa USD → BRL.', 'error');
    setLoading(true);
    try {
      await updateRates({ low, high, brlToUsd, usdToBrl });
      setCurrentRates({ low, high, brlToUsd, usdToBrl });
      toast('Tasas actualizadas ✅');
    } catch { toast('Error al guardar.', 'error'); }
    setLoading(false);
  };

  const handleSearch = async () => {
    if (!searchVal.trim()) return;
    setLoading(true);
    try {
      let user = null;
      if (searchType === 'cpf')    user = await findUserByCpf(searchVal);
      if (searchType === 'email')  user = await findUserByEmail(searchVal);
      if (searchType === 'nombre') user = await findUserByName(searchVal);
      if (user?.referred_by) {
        const referrer = await findUserByUid(user.referred_by);
        if (referrer) user.referrerData = referrer;
      }
      if (user) user.referredUsers = await findReferredUsers(user.uid);
      setFoundUser(user);
      if (!user) toast('Usuario no encontrado.', 'error');
    } catch { toast('Error en la búsqueda.', 'error'); }
    setLoading(false);
  };

  const handleAddClicks = async (amount) => {
    if (!foundUser || loading) return;
    const n = parseInt(amount || clicksToAdd);
    if (!n || n <= 0) return toast('Cantidad inválida.', 'error');
    setLoading(true);
    try {
      await addServiceClicks(foundUser.uid, n);
      await new Promise(r => setTimeout(r, 800));
      const updated = await findUserByUid(foundUser.uid);
      if (updated) {
        if (updated.referred_by) {
          const referrer = await findUserByUid(updated.referred_by);
          if (referrer) updated.referrerData = referrer;
        }
        updated.referredUsers = await findReferredUsers(updated.uid);
        setFoundUser(updated);
      }
      toast(`+${n} CLICKs agregados a ${foundUser.name} ✅`);
      setClicksToAdd('');
    } catch { toast('Error al agregar.', 'error'); }
    setLoading(false);
  };

  const handleResetClicks = async () => {
    if (!foundUser || loading) return;
    if (!window.confirm(`¿Resetear CLICKs de ${foundUser.name} a 0?`)) return;
    setLoading(true);
    try {
      await resetClicks(foundUser.uid);
      await new Promise(r => setTimeout(r, 800));
      const updated = await findUserByUid(foundUser.uid);
      if (updated) {
        if (updated.referred_by) {
          const referrer = await findUserByUid(updated.referred_by);
          if (referrer) updated.referrerData = referrer;
        }
        updated.referredUsers = await findReferredUsers(updated.uid);
        setFoundUser(updated);
      }
      toast('CLICKs reseteados a 0. ✅');
    } catch { toast('Error.', 'error'); }
    setLoading(false);
  };

  React.useEffect(() => {
    if (tab === 'canjes') {
      setCanjesLoading(true);
      getAllCanjes().then(list => { setCanjesList(list); setCanjesLoading(false); });
    }
  }, [tab]);

  const handleMarkProcessed = async (id) => {
    try {
      await markCanjeProcessed(id);
      setCanjesList(list => list.map(c => c.id === id ? { ...c, status: 'procesado' } : c));
      toast('Canje marcado como procesado ✅');
    } catch { toast('Error al actualizar el canje.', 'error'); }
  };

  const handleBuscarVale = async () => {
    if (!valeCodigo.trim()) return;
    setValeLoading(true);
    setValeResult(null);
    try {
      const vale = await buscarValePorCodigo(valeCodigo);
      if (!vale) toast('No se encontró ningún vale con ese código.', 'error');
      setValeResult(vale);
    } catch { toast('Error al buscar el vale.', 'error'); }
    setValeLoading(false);
  };

  const handleMarcarValeUsado = async () => {
    if (!valeResult) return;
    setValeMarcando(true);
    try {
      await marcarValeUsado(valeResult.id);
      setValeResult(v => ({ ...v, estado: 'usado', usado_at: new Date().toISOString() }));
      toast('Vale marcado como usado ✅');
    } catch { toast('Error al marcar el vale.', 'error'); }
    setValeMarcando(false);
  };

  React.useEffect(() => {
    if (tab === 'referidos_vuelos') {
      setVuelosReferidosLoading(true);
      getVuelosReferidos().then(list => { setVuelosReferidosList(list); setVuelosReferidosLoading(false); });
    }
  }, [tab]);

  React.useEffect(() => {
    if (tab === 'solicitudes') {
      setSolicitudesLoading(true);
      getAllSolicitudes().then(list => { setSolicitudesList(list); setSolicitudesLoading(false); });
    }
  }, [tab]);

  const handleMarcarVueloPagado = async (id) => {
    const input = window.prompt('¿Cuántas personas del grupo cerraron el vuelo?');
    if (input === null) return;
    const personas = parseInt(input, 10);
    if (!personas || personas <= 0) return toast('Cantidad inválida.', 'error');
    setMarcandoPagoId(id);
    try {
      await markVueloReferidoPagado(id, personas);
      const list = await getVuelosReferidos();
      setVuelosReferidosList(list);
      toast('Cotización marcada como pagada ✅');
    } catch { toast('Error al marcar como pagado.', 'error'); }
    setMarcandoPagoId(null);
  };

  const handleEnviarAnuncio = async () => {
    if (!anuncioMensaje.trim()) return toast('Escribe el mensaje del anuncio.', 'error');
    if (!window.confirm('Esto le va a llegar a TODOS los que tienen la app instalada y notificaciones activadas. ¿Confirmas?')) return;
    setEnviandoAnuncio(true);
    try {
      const r = await broadcastNotificacion(anuncioTitulo.trim() || 'Click Travel Agency', anuncioMensaje.trim());
      toast(`Enviado a ${r.sent} de ${r.total} 📢${r.failed ? ` (${r.failed} fallaron)` : ''}`);
      setAnuncioMensaje('');
    } catch (err) { toast(err.message || 'Error al enviar el anuncio.', 'error'); }
    setEnviandoAnuncio(false);
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'var(--bg)', zIndex: 300, overflowY: 'auto' }}>
      <div style={{ padding: '24px 16px 40px', maxWidth: 480, margin: '0 auto' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <div>
            <p style={{ fontSize: 11, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1 }}>PANEL</p>
            <h2 style={{ fontSize: 20, fontWeight: 800 }}>Administrador</h2>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => {
              navigator.clipboard?.writeText(`${window.location.origin}/?tab=more&admin=tasa`);
              toast('Link copiado 📋 -- ábrelo en Chrome y usa "Agregar a pantalla de inicio" para tener un acceso directo.');
            }} style={{ background: 'rgba(255,184,0,0.15)', border: '1px solid rgba(255,184,0,0.4)', color: 'var(--gold, #FFB800)', borderRadius: 8, padding: '8px 14px', fontSize: 13 }}>🔗 Acceso directo</button>
            <button onClick={onClose} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', color: 'var(--muted)', borderRadius: 8, padding: '8px 14px', fontSize: 13 }}>✕ Cerrar</button>
          </div>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', background: 'var(--navy-card)', borderRadius: 10, padding: 4, marginBottom: 20, gap: 4 }}>
          {[{ id: 'cotizador', label: '🧮 Cotizador' }, { id: 'precios', label: '📊 Precios de referencia' }, { id: 'millas', label: '✈️ Orçamento' }, { id: 'tasa', label: '💱 Tasas' }, { id: 'usuarios', label: '👥 Usuarios' }, { id: 'solicitudes', label: '🧾 Solicitudes' }, { id: 'canjes', label: '🎁 Canjes' }, { id: 'ganancia', label: '💰 Ganancia' }, { id: 'referidos_vuelos', label: '✈️ Referidos Vuelos', oculta: true }, { id: 'vuelos_guyana', label: '🌴 Vuelos Guyana' }, { id: 'imagenes', label: '🖼️ Generador de Imágenes', oculta: true }, { id: 'nuestros_clientes', label: '⭐ Nuestros Clientes' }, { id: 'anuncios', label: '📢 Anuncios', oculta: true }]
            // Una pestaña escondida igual se muestra si ya está abierta (por ejemplo, al llegar desde una notificación).
            .filter(t => !t.oculta || mostrarOcultas || tab === t.id)
            .map(t => (
            <button key={t.id} onClick={() => setTab(t.id)} style={{
              flex: '1 1 45%', padding: '9px 0', borderRadius: 8, fontSize: 12, fontWeight: 600,
              background: tab === t.id ? 'var(--orange)' : 'transparent',
              color: tab === t.id ? 'white' : 'var(--muted)', transition: 'all 0.2s',
            }}>{t.label}</button>
          ))}
        </div>

        {tab === 'cotizador' && <CotizadorPanel />}

        {tab === 'precios' && <CotizadorPrecios />}

        {tab === 'millas' && <MillasPanel />}

        {tab === 'tasa' && (
          <div>
            {/* Tasas actuales — Remesas */}
            {currentRates && (
              <>
                <p style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, letterSpacing: 1, marginBottom: 10 }}>TASAS ACTUALES — REMESAS (CUP/BRL)</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
                  <div style={{ background: 'rgba(0,196,140,0.08)', border: '1px solid rgba(0,196,140,0.2)', borderRadius: 14, padding: 14, textAlign: 'center' }}>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 4 }}>Menos de R$100</p>
                    <p style={{ fontSize: 18, fontWeight: 800, color: 'var(--success)', lineHeight: 1.2 }}>
                      {currentRates.low > 0 ? `${currentRates.low.toFixed(2)} CUP` : '—'}
                    </p>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>por BRL</p>
                  </div>
                  <div style={{ background: 'rgba(255,184,0,0.08)', border: '1px solid rgba(255,184,0,0.2)', borderRadius: 14, padding: 14, textAlign: 'center' }}>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 4 }}>R$100 o más</p>
                    <p style={{ fontSize: 18, fontWeight: 800, color: 'var(--gold)', lineHeight: 1.2 }}>
                      {currentRates.high > 0 ? `${currentRates.high.toFixed(2)} CUP` : '—'}
                    </p>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>por BRL</p>
                  </div>
                </div>

                {/* Tasas actuales — Divisas */}
                <p style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, letterSpacing: 1, marginBottom: 10 }}>TASAS ACTUALES — DIVISAS</p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 20 }}>
                  <div style={{ background: 'rgba(255,107,0,0.08)', border: '1px solid rgba(255,107,0,0.2)', borderRadius: 14, padding: 14, textAlign: 'center' }}>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 4 }}>🇧🇷 BRL → USD 🇺🇸</p>
                    <p style={{ fontSize: 18, fontWeight: 800, color: 'var(--orange)', lineHeight: 1.2 }}>
                      {currentRates.brlToUsd > 0 ? `${currentRates.brlToUsd.toFixed(2)}` : '—'}
                    </p>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>BRL por 1 USD</p>
                  </div>
                  <div style={{ background: 'rgba(11,76,140,0.15)', border: '1px solid rgba(11,76,140,0.4)', borderRadius: 14, padding: 14, textAlign: 'center' }}>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginBottom: 4 }}>🇺🇸 USD → BRL 🇧🇷</p>
                    <p style={{ fontSize: 18, fontWeight: 800, color: 'var(--white)', lineHeight: 1.2 }}>
                      {currentRates.usdToBrl > 0 ? `${currentRates.usdToBrl.toFixed(2)}` : '—'}
                    </p>
                    <p style={{ fontSize: 10, color: 'var(--muted)', marginTop: 2 }}>USD por 1 BRL</p>
                  </div>
                </div>
              </>
            )}

            {/* Inputs remesas */}
            <p style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, letterSpacing: 1, marginBottom: 10 }}>ACTUALIZAR REMESAS</p>
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>TASA — MONTOS MENORES A R$ 100</label>
            <input value={rateLow} onChange={e => setRateLow(e.target.value)} placeholder="Ej: 290.00" inputMode="decimal" style={{ marginBottom: 16 }} />
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>TASA — MONTOS DE R$ 100 O MÁS</label>
            <input value={rateHigh} onChange={e => setRateHigh(e.target.value)} placeholder="Ej: 295.50" inputMode="decimal" style={{ marginBottom: 24 }} />

            {/* Inputs divisas */}
            <p style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, letterSpacing: 1, marginBottom: 10 }}>ACTUALIZAR DIVISAS</p>
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>BRL → USD (cuántos BRL por 1 USD)</label>
            <input value={rateBrlUsd} onChange={e => setRateBrlUsd(e.target.value)} placeholder="Ej: 5.80" inputMode="decimal" style={{ marginBottom: 16 }} />
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>USD → BRL (cuántos USD por 1 BRL)</label>
            <input value={rateUsdBrl} onChange={e => setRateUsdBrl(e.target.value)} placeholder="Ej: 4.60" inputMode="decimal" style={{ marginBottom: 20 }} />

            <button className="btn-primary" onClick={handleSaveRates} disabled={loading}>
              {loading ? <span className="spinner" /> : '💾 Guardar todas las tasas'}
            </button>
            <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 12, lineHeight: 1.7 }}>
              💡 Actualiza diariamente. Los cambios se reflejan de inmediato en la app.
            </p>
          </div>
        )}

        {tab === 'usuarios' && (
          <div>
            <p className="section-label">BUSCAR USUARIO</p>
            <div style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap' }}>
              {[{ id: 'cpf', label: 'Por CPF' }, { id: 'email', label: 'Por Correo' }, { id: 'nombre', label: 'Por Nombre' }].map(t => (
                <button key={t.id} onClick={() => { setSearchType(t.id); setSearchVal(''); setFoundUser(null); }} style={{
                  padding: '8px 14px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                  background: searchType === t.id ? 'var(--orange)' : 'var(--navy-card)',
                  color: searchType === t.id ? 'white' : 'var(--muted)',
                  border: `1px solid ${searchType === t.id ? 'var(--orange)' : 'var(--navy-border)'}`,
                }}>{t.label}</button>
              ))}
            </div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
              <input value={searchVal} onChange={e => setSearchVal(e.target.value)}
                placeholder={
                  searchType === 'cpf'    ? '000.000.000-00' :
                  searchType === 'email'  ? 'correo@ejemplo.com' :
                  'Nombre del usuario'
                }
                style={{ flex: 1 }} onKeyDown={e => e.key === 'Enter' && handleSearch()} />
              <button className="btn-primary" onClick={handleSearch} disabled={loading} style={{ width: 48, padding: 0, flexShrink: 0 }}>
                {loading ? <span className="spinner" /> : '🔍'}
              </button>
            </div>

            {foundUser && (
              <div>
                <div style={{ background: 'var(--navy-card)', border: '1px solid rgba(255,107,0,0.3)', borderRadius: 14, padding: 16, marginBottom: 16 }}>
                  {[
                    ['Nombre',   foundUser.name || '—'],
                    ['Correo',   foundUser.email],
                    ['CPF',      formatCpf(foundUser.cpf || '')],
                    ['Teléfono', foundUser.phone || '—'],
                  ].map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                      <span style={{ fontSize: 12, color: 'var(--muted)' }}>{k}</span>
                      <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)', maxWidth: '55%', textAlign: 'right', wordBreak: 'break-all' }}>{v}</span>
                    </div>
                  ))}
                  <div style={{ height: 1, background: 'var(--navy-border)', margin: '10px 0' }} />
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: 13, color: 'var(--muted)' }}>CLICKs</span>
                    <span style={{ fontSize: 24, fontWeight: 800, color: 'var(--gold)' }}>⭐ {foundUser.clicks || 0}</span>
                  </div>
                  {foundUser.referrerData && (
                    <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid var(--navy-border)' }}>
                      <p style={{ fontSize: 11, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1, marginBottom: 8 }}>🎁 REFERIDO POR</p>
                      {[
                        ['Nombre', foundUser.referrerData.name || '—'],
                        ['Correo', foundUser.referrerData.email],
                        ['CPF',   formatCpf(foundUser.referrerData.cpf || '')],
                      ].map(([k, v]) => (
                        <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                          <span style={{ fontSize: 12, color: 'var(--muted)' }}>{k}</span>
                          <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)', maxWidth: '55%', textAlign: 'right', wordBreak: 'break-all' }}>{v}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid var(--navy-border)' }}>
                    <p style={{ fontSize: 11, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1, marginBottom: 8 }}>👥 PERSONAS QUE HA REFERIDO</p>
                    {foundUser.referredUsers && foundUser.referredUsers.length > 0 ? (
                      foundUser.referredUsers.map((r, i) => (
                        <div key={i} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
                          <span style={{ fontSize: 12, color: 'var(--white)', fontWeight: 600 }}>{r.name || '—'}</span>
                          <span style={{ fontSize: 12, color: 'var(--muted)', maxWidth: '55%', textAlign: 'right', wordBreak: 'break-all' }}>{r.email}</span>
                        </div>
                      ))
                    ) : (
                      <p style={{ fontSize: 12, color: 'var(--muted)' }}>Aún no ha referido a nadie</p>
                    )}
                  </div>
                </div>

                <p className="section-label">AGREGAR CLICKs</p>
                <div style={{ display: 'flex', gap: 8, marginBottom: 10 }}>
                  <input value={clicksToAdd} onChange={e => setClicksToAdd(e.target.value)} placeholder="Cantidad" inputMode="numeric" style={{ flex: 1 }} />
                  <button className="btn-primary" onClick={() => handleAddClicks()} disabled={loading} style={{ width: 80, padding: 0 }}>
                    {loading ? <span className="spinner" /> : '+ Agregar'}
                  </button>
                </div>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
                  {[50, 100, 200, 500].map(n => (
                    <button key={n} onClick={() => handleAddClicks(n)} disabled={loading} style={{
                      background: 'var(--navy-card)', border: '1px solid var(--orange)',
                      color: 'var(--orange)', fontWeight: 700, fontSize: 13,
                      borderRadius: 8, padding: '7px 14px',
                      opacity: loading ? 0.5 : 1,
                    }}>+{n}</button>
                  ))}
                </div>
                <button onClick={handleResetClicks} disabled={loading} style={{
                  width: '100%', background: 'transparent', border: '1px solid var(--error)',
                  color: 'var(--error)', fontWeight: 600, fontSize: 13,
                  borderRadius: 8, padding: '11px 0',
                  opacity: loading ? 0.5 : 1,
                }}>🗑️ Resetear CLICKs a 0</button>
              </div>
            )}
          </div>
        )}

        {tab === 'canjes' && (
          <div>
            <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
              {[{ id: 'recargas', label: '📱 Recargas' }, { id: 'vales', label: '🎫 Vales' }].map(t => (
                <button key={t.id} onClick={() => { setCanjesSubTab(t.id); setValeCodigo(''); setValeResult(null); }} style={{
                  flex: 1, padding: '9px 0', borderRadius: 8, fontSize: 12, fontWeight: 700,
                  background: canjesSubTab === t.id ? 'var(--orange)' : 'var(--navy-card)',
                  color: canjesSubTab === t.id ? 'white' : 'var(--muted)',
                  border: `1px solid ${canjesSubTab === t.id ? 'var(--orange)' : 'var(--navy-border)'}`,
                }}>{t.label}</button>
              ))}
            </div>

            {canjesSubTab === 'vales' && (
              <div>
                <p className="section-label">BUSCAR VALE POR CÓDIGO</p>
                <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
                  <input value={valeCodigo} onChange={e => setValeCodigo(e.target.value.toUpperCase())}
                    placeholder="CLICK-TR-XXXX" style={{ flex: 1 }} onKeyDown={e => e.key === 'Enter' && handleBuscarVale()} />
                  <button className="btn-primary" onClick={handleBuscarVale} disabled={valeLoading} style={{ width: 48, padding: 0, flexShrink: 0 }}>
                    {valeLoading ? <span className="spinner" /> : '🔍'}
                  </button>
                </div>

                {valeResult && (
                  <div style={{ background: 'var(--navy-card)', border: '1px solid rgba(255,107,0,0.3)', borderRadius: 14, padding: 16 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                      <p style={{ fontSize: 16, fontWeight: 800, color: 'var(--white)' }}>{valeResult.codigo}</p>
                      <span style={{
                        fontSize: 11, fontWeight: 700, borderRadius: 6, padding: '4px 10px',
                        background: valeResult.estado === 'disponible' ? 'rgba(0,196,140,0.15)' : valeResult.estado === 'usado' ? 'rgba(107,130,168,0.15)' : 'rgba(255,60,60,0.12)',
                        color: valeResult.estado === 'disponible' ? 'var(--success)' : valeResult.estado === 'usado' ? 'var(--muted)' : 'var(--error)',
                      }}>{valeResult.estado === 'disponible' ? 'Disponible' : valeResult.estado === 'usado' ? 'Usado' : 'Vencido'}</span>
                    </div>
                    {[
                      ['Generado por', `${valeResult.user_name || '—'} (${valeResult.user_email || '—'})`],
                      ['Tipo',         valeResult.tipo === 'traduccion' ? 'Traducción' : 'Vuelo'],
                      ['Descuento',    valeResult.descuento],
                      ['Nivel',        `⭐ ${valeResult.nivel} CLICKs`],
                      ['Vence',        new Date(valeResult.expira_at).toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric' })],
                    ].map(([k, v]) => (
                      <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                        <span style={{ fontSize: 12, color: 'var(--muted)' }}>{k}</span>
                        <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)', maxWidth: '60%', textAlign: 'right', wordBreak: 'break-word' }}>{v}</span>
                      </div>
                    ))}
                    {valeResult.estado === 'disponible' && (
                      <button onClick={handleMarcarValeUsado} disabled={valeMarcando} style={{
                        width: '100%', marginTop: 8, background: 'rgba(0,196,140,0.12)', border: '1px solid rgba(0,196,140,0.3)',
                        color: 'var(--success)', fontWeight: 700, fontSize: 13, borderRadius: 8, padding: '9px 0',
                        opacity: valeMarcando ? 0.6 : 1,
                      }}>{valeMarcando ? <span className="spinner" /> : '✅ Marcar como usado'}</button>
                    )}
                  </div>
                )}
              </div>
            )}

            {canjesSubTab === 'recargas' && (
              <>
            <p className="section-label">TODOS LOS CANJES</p>
            {canjesLoading && <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>Cargando...</p>}
            {!canjesLoading && canjesList.length === 0 && (
              <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>No hay canjes registrados.</p>
            )}
            {canjesList.map(c => (
              <div key={c.id} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 16, marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                  <div>
                    <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>{c.user_name || '—'}</p>
                    <p style={{ fontSize: 11, color: 'var(--muted)' }}>{c.user_email}</p>
                  </div>
                  <span style={{
                    fontSize: 11, fontWeight: 700, borderRadius: 6, padding: '4px 10px',
                    background: c.status === 'procesado' ? 'rgba(0,196,140,0.15)' : 'rgba(255,107,0,0.15)',
                    color: c.status === 'procesado' ? 'var(--success)' : 'var(--orange)',
                  }}>{c.status === 'procesado' ? 'Procesado' : 'Pendiente'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Nivel</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>⭐ {c.level} CLICKs</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Recarga</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>R${c.recharge_price} → R${c.discounted_price}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: c.status === 'pendiente' ? 12 : 0 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Fecha</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>
                    {new Date(c.created_at).toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
                {c.status === 'pendiente' && (
                  <button onClick={() => handleMarkProcessed(c.id)} style={{
                    width: '100%', background: 'rgba(0,196,140,0.12)', border: '1px solid rgba(0,196,140,0.3)',
                    color: 'var(--success)', fontWeight: 700, fontSize: 13, borderRadius: 8, padding: '9px 0',
                  }}>✅ Marcar procesado</button>
                )}
              </div>
            ))}
              </>
            )}
          </div>
        )}

        {tab === 'solicitudes' && (
          <div>
            <p style={{ fontSize: 12, color: 'var(--muted)', lineHeight: 1.6, marginBottom: 16 }}>
              Respaldo de cada solicitud enviada por WhatsApp (Recargas, Remesas, Vuelos, Traducciones). Es solo un registro de consulta — la confirmación real sigue pasando por WhatsApp.
            </p>
            <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
              {['todas', 'Recargas', 'Remesas', 'Vuelos', 'Traducciones'].map(f => (
                <button key={f} onClick={() => setSolicitudesFiltro(f)} style={{
                  padding: '7px 12px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                  background: solicitudesFiltro === f ? 'var(--orange)' : 'var(--navy-card)',
                  color: solicitudesFiltro === f ? 'white' : 'var(--muted)',
                  border: `1px solid ${solicitudesFiltro === f ? 'var(--orange)' : 'var(--navy-border)'}`,
                }}>{f === 'todas' ? 'Todas' : f}</button>
              ))}
            </div>

            {solicitudesLoading && <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>Cargando...</p>}
            {!solicitudesLoading && solicitudesList.length === 0 && (
              <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>No hay solicitudes registradas.</p>
            )}
            {solicitudesList
              .filter(s => solicitudesFiltro === 'todas' || s.tipo === solicitudesFiltro)
              .map(s => (
                <div key={s.id} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 16, marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                    <div>
                      <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>{s.cliente?.name || '—'}</p>
                      <p style={{ fontSize: 11, color: 'var(--muted)' }}>{s.cliente?.email || '—'}</p>
                    </div>
                    <span style={{
                      fontSize: 11, fontWeight: 700, borderRadius: 6, padding: '4px 10px',
                      background: 'rgba(255,107,0,0.15)', color: 'var(--orange)', whiteSpace: 'nowrap',
                    }}>{s.tipo}</span>
                  </div>
                  {(s.cliente?.phone || s.cliente?.cpf) && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                      <span style={{ fontSize: 12, color: 'var(--muted)' }}>{s.cliente?.phone ? 'Teléfono' : 'CPF'}</span>
                      <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>{s.cliente?.phone || formatCpf(s.cliente?.cpf || '')}</span>
                    </div>
                  )}
                  <div style={{ background: 'rgba(255,107,0,0.06)', border: '1px solid rgba(255,107,0,0.18)', borderRadius: 8, padding: '8px 10px', margin: '8px 0 4px' }}>
                    <p style={{ fontSize: 12, color: 'var(--white)' }}>{s.detalle}</p>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 11, color: 'var(--muted)' }}>Fecha</span>
                    <span style={{ fontSize: 11, color: 'var(--muted)' }}>
                      {new Date(s.created_at).toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                    </span>
                  </div>
                </div>
              ))}
          </div>
        )}

        {tab === 'ganancia' && (
          <div>
            <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 20, lineHeight: 1.6 }}>
              🔒 Calculadora privada. Ingresa los datos del día para ver tu margen de ganancia.
            </p>
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>CUP RECIBIDOS POR OPERACIÓN</label>
            <input value={cup} onChange={e => setCup(e.target.value)} placeholder="Ej: 14700" inputMode="decimal" style={{ marginBottom: 16 }} />
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>USDT PAGADO</label>
            <input value={usdt} onChange={e => setUsdt(e.target.value)} placeholder="Ej: 820" inputMode="decimal" style={{ marginBottom: 16 }} />
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>TASA BRL DEL DÍA (BRL por 1 USDT)</label>
            <input value={brl} onChange={e => setBrl(e.target.value)} placeholder="Ej: 5.1" inputMode="decimal" style={{ marginBottom: 24 }} />

            {tasaCliente !== null && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ background: 'rgba(255,184,0,0.08)', border: '1px solid rgba(255,184,0,0.25)', borderRadius: 14, padding: 18, textAlign: 'center' }}>
                  <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6, letterSpacing: 0.5 }}>TASA QUE OFRECES AL CLIENTE</p>
                  <p style={{ fontSize: 28, fontWeight: 800, color: 'var(--gold)' }}>
                    {tasaCliente.toFixed(2)} <span style={{ fontSize: 14 }}>CUP / BRL</span>
                  </p>
                </div>
                <div style={{
                  background: margen >= 0 ? 'rgba(0,196,140,0.08)' : 'rgba(255,107,0,0.08)',
                  border: `1px solid ${margen >= 0 ? 'rgba(0,196,140,0.25)' : 'rgba(255,107,0,0.25)'}`,
                  borderRadius: 14, padding: 18, textAlign: 'center'
                }}>
                  <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6, letterSpacing: 0.5 }}>TU MARGEN DE GANANCIA</p>
                  <p style={{ fontSize: 34, fontWeight: 800, color: margen >= 0 ? 'var(--success)' : 'var(--orange)' }}>
                    {Math.abs(margen).toFixed(2)}%
                  </p>
                  <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>por cada R$100 cobrados al cliente</p>
                </div>
                <div style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 16 }}>
                  <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 10, fontWeight: 700, letterSpacing: 0.5 }}>RESUMEN</p>
                  {[
                    ['CUP ÷ USDT', `${(parseFloat(cup) / parseFloat(usdt)).toFixed(4)} CUP/USDT`],
                    ['× Tasa BRL', `${parseFloat(brl)} BRL/USDT`],
                    ['= Tasa cliente', `${tasaCliente.toFixed(2)} CUP/BRL`],
                    ['Tu ganancia', `R$ ${Math.abs(margen).toFixed(2)} por cada R$ 100`],
                  ].map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                      <span style={{ fontSize: 12, color: 'var(--muted)' }}>{k}</span>
                      <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--white)' }}>{v}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{ height: 1, background: 'var(--navy-border)', margin: '28px 0 20px' }} />

            <p style={{ fontSize: 11, color: 'var(--muted)', fontWeight: 700, letterSpacing: 1, marginBottom: 6 }}>🇪🇺 GANANCIA COPA — EUROS RECIBIDOS → REALES</p>
            <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.6 }}>
              🔒 Calculadora privada. Cuando cobres una venta de Copa en euros, mete cuántos euros recibiste y la tasa del banco/casa de cambio de hoy para ver a cuántos reales equivale.
            </p>
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>EUROS RECIBIDOS</label>
            <input value={eurRecibidos} onChange={e => setEurRecibidos(e.target.value)} placeholder="Ej: 350" inputMode="decimal" style={{ marginBottom: 16 }} />
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>TASA EUR → BRL DEL DÍA (BRL por 1 EUR)</label>
            <input value={tasaEurBrlDia} onChange={e => setTasaEurBrlDia(e.target.value)} placeholder="Ej: 6.10" inputMode="decimal" style={{ marginBottom: 20 }} />

            {realesPorEuros !== null && (
              <div style={{ background: 'rgba(0,196,140,0.08)', border: '1px solid rgba(0,196,140,0.25)', borderRadius: 14, padding: 18, textAlign: 'center' }}>
                <p style={{ fontSize: 11, color: 'var(--muted)', marginBottom: 6, letterSpacing: 0.5 }}>TE QUEDAN</p>
                <p style={{ fontSize: 28, fontWeight: 800, color: 'var(--success)' }}>
                  R$ {realesPorEuros.toFixed(2)}
                </p>
                <p style={{ fontSize: 12, color: 'var(--muted)', marginTop: 4 }}>
                  {eurRecibidos} EUR × {tasaEurBrlDia} = R$ {realesPorEuros.toFixed(2)}
                </p>
              </div>
            )}
          </div>
        )}

        {tab === 'referidos_vuelos' && (
          <div>
            <p className="section-label">COTIZACIONES DE VUELO REFERIDAS</p>
            {vuelosReferidosLoading && <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>Cargando...</p>}
            {!vuelosReferidosLoading && vuelosReferidosList.length === 0 && (
              <p style={{ color: 'var(--muted)', fontSize: 13, textAlign: 'center' }}>No hay cotizaciones referidas todavía.</p>
            )}
            {vuelosReferidosList.map(v => (
              <div key={v.id} style={{ background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 14, padding: 16, marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 10 }}>
                  <div>
                    <p style={{ fontSize: 10, color: 'var(--orange)', fontWeight: 700, letterSpacing: 1 }}>COTIZÓ</p>
                    <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>{v.cotizante?.name || '—'}</p>
                    <p style={{ fontSize: 11, color: 'var(--muted)' }}>{v.cotizante?.email || '—'}</p>
                  </div>
                  <span style={{
                    fontSize: 11, fontWeight: 700, borderRadius: 6, padding: '4px 10px', whiteSpace: 'nowrap',
                    background: v.pagado ? 'rgba(0,196,140,0.15)' : 'rgba(255,107,0,0.15)',
                    color: v.pagado ? 'var(--success)' : 'var(--orange)',
                  }}>{v.pagado ? 'Pagado' : 'Pendiente'}</span>
                </div>

                <div style={{ marginBottom: 10, paddingBottom: 10, borderBottom: '1px solid var(--navy-border)' }}>
                  <p style={{ fontSize: 10, color: 'var(--gold)', fontWeight: 700, letterSpacing: 1, marginBottom: 4 }}>🎁 REFERIDO POR</p>
                  <p style={{ fontSize: 13, fontWeight: 600, color: 'var(--white)' }}>{v.referidor?.name || '—'}</p>
                  <p style={{ fontSize: 11, color: 'var(--muted)' }}>{v.referidor?.email || '—'}</p>
                </div>

                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Ruta</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)', maxWidth: '60%', textAlign: 'right' }}>{v.origen || '—'} → {v.destino || '—'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Fecha solicitada</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>{v.fecha_solicitada || '—'}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Pasajeros</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>{v.adultos ?? 1} adulto(s){v.infantes > 0 ? ` · ${v.infantes} infante(s)` : ''}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: v.pagado ? 4 : 12 }}>
                  <span style={{ fontSize: 12, color: 'var(--muted)' }}>Cotizado el</span>
                  <span style={{ fontSize: 12, fontWeight: 600, color: 'var(--white)' }}>
                    {new Date(v.created_at).toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>

                {v.pagado ? (
                  <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span style={{ fontSize: 12, color: 'var(--muted)' }}>Pagado el</span>
                    <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--success)', textAlign: 'right' }}>
                      {v.fecha_pago ? new Date(v.fecha_pago).toLocaleDateString('es', { day: '2-digit', month: '2-digit', year: 'numeric' }) : '—'} — {v.monto_usd ?? 0} USD por {v.personas_pagadas ?? 0} persona(s)
                    </span>
                  </div>
                ) : (
                  <button onClick={() => handleMarcarVueloPagado(v.id)} disabled={marcandoPagoId === v.id} style={{
                    width: '100%', background: 'rgba(0,196,140,0.12)', border: '1px solid rgba(0,196,140,0.3)',
                    color: 'var(--success)', fontWeight: 700, fontSize: 13, borderRadius: 8, padding: '9px 0',
                    opacity: marcandoPagoId === v.id ? 0.6 : 1,
                  }}>{marcandoPagoId === v.id ? 'Guardando...' : '✅ Marcar como pagado'}</button>
                )}
              </div>
            ))}
          </div>
        )}

        {tab === 'vuelos_guyana' && <VuelosGuyanaAdminPanel />}

        {tab === 'imagenes' && <GeneradorImagenesPanel />}

        {tab === 'nuestros_clientes' && <NuestrosClientesAdminPanel initialTab={initialSub} />}

        {tab === 'anuncios' && (
          <div>
            <p className="section-label">ENVIAR A TODOS</p>
            <p style={{ fontSize: 12, color: 'var(--muted)', marginBottom: 16, lineHeight: 1.6 }}>
              Le llega como notificación push a cualquiera que tenga la app instalada y las notificaciones activadas -- úsalo para promociones o avisos importantes, no para cosas del día a día.
            </p>
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>TÍTULO</label>
            <input value={anuncioTitulo} onChange={(e) => setAnuncioTitulo(e.target.value)} placeholder="Click Travel Agency" style={{ marginBottom: 16 }} />
            <label style={{ fontSize: 12, color: 'var(--muted)', fontWeight: 700, letterSpacing: 0.5 }}>MENSAJE</label>
            <textarea value={anuncioMensaje} onChange={(e) => setAnuncioMensaje(e.target.value)} rows={4} placeholder="Ej: ¡Nueva promoción de vuelos a Guyana esta semana!" style={{ marginBottom: 20, resize: 'vertical' }} />
            <button className="btn-primary" onClick={handleEnviarAnuncio} disabled={enviandoAnuncio}>
              {enviandoAnuncio ? <span className="spinner" /> : '📢 Enviar a todos'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

function ThemeSwitcher() {
  const { theme, setTheme } = useTheme();
  const opciones = [
    { id: 'light', label: '☀️ Claro' },
    { id: 'dark', label: '🌙 Oscuro' },
    { id: 'system', label: '📱 Sistema' },
  ];

  return (
    <div style={{ display: 'flex', background: 'var(--navy-card)', border: '1px solid var(--navy-border)', borderRadius: 12, padding: 4, gap: 4 }}>
      {opciones.map((o) => (
        <button key={o.id} onClick={() => setTheme(o.id)} style={{
          flex: 1, padding: '10px 0', borderRadius: 9, fontSize: 12, fontWeight: 700,
          background: theme === o.id ? 'var(--orange)' : 'transparent',
          color: theme === o.id ? 'white' : 'var(--muted)',
          transition: 'all 0.2s',
        }}>{o.label}</button>
      ))}
    </div>
  );
}

export default function MoreScreen({ openAdmin, onAdminOpened, adminDeepLink }) {
  const { isAdmin, user } = useAuth();
  const [showAdmin, setShowAdmin] = useState(false);
  const [pushActive, setPushActive] = useState(false);
  const [activatingPush, setActivatingPush] = useState(false);

  // El permiso del navegador ("granted") no garantiza que exista una
  // suscripción real guardada -- si subscribeToPush falló a mitad de camino
  // (ej. el upsert a push_subscriptions) el permiso queda concedido pero
  // nunca llega ninguna notificación. Se verifica la suscripción real del
  // navegador en vez de asumirla a partir del permiso.
  useEffect(() => {
    if (!isPushSupported()) return;
    navigator.serviceWorker.ready
      .then((reg) => reg.pushManager.getSubscription())
      .then((sub) => setPushActive(!!sub))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if ((openAdmin || adminDeepLink) && isAdmin) {
      setShowAdmin(true);
      onAdminOpened?.();
    }
  }, [openAdmin, adminDeepLink, isAdmin]);

  const handleActivatePush = async () => {
    if (!user?.uid) return;
    setActivatingPush(true);
    const result = await subscribeToPush(user.uid, user.email === ADMIN_EMAIL);
    setActivatingPush(false);
    if (result.ok) { setPushActive(true); toast('¡Notificaciones activadas! 🔔'); }
    else toast(`No se pudieron activar: ${result.error}`, 'error');
  };

  const socials = [
    { icon: '📸', label: 'Instagram', handle: '@clicktravelagencyes', url: 'https://instagram.com/clicktravelagencyes', color: 'rgba(193,53,132,0.15)' },
    { icon: '🎵', label: 'TikTok', handle: '@clickacubaturuta', url: 'https://tiktok.com/@clickacubaturuta', color: 'rgba(255,0,80,0.12)' },
    { icon: '👥', label: 'Facebook', handle: 'Click Travel Agency', url: 'https://www.facebook.com/profile.php?id=61574033253490', color: 'rgba(24,119,242,0.12)' },
    { icon: '💬', label: 'Grupo de WhatsApp', handle: 'Noticias y ofertas diarias', url: GRUPO_WHATSAPP_URL, color: 'rgba(37,211,102,0.12)' },
  ];

  const payments = [
    { icon: '⚡', label: 'PIX', desc: 'Transferencia instantánea en Brasil' },
    { icon: '💳', label: 'CL (Cartão)', desc: 'Tarjetas de crédito y débito' },
    { icon: '🏦', label: 'ACH / Wire Transfer', desc: 'Transferencia internacional' },
    { icon: '💵', label: 'USD en Efectivo', desc: 'Para operaciones directas en Cuba' },
  ];

  return (
    <div className="page" style={{ paddingTop: 24 }}>
      <h2 style={{ fontSize: 22, fontWeight: 800, marginBottom: 20 }}>Más</h2>

      <p className="section-label">SÍGUENOS</p>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 24 }}>
        {socials.map(s => (
          <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" style={{
            background: s.color, border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: 14, padding: '14px 16px',
            display: 'flex', alignItems: 'center', gap: 14,
          }}>
            <span style={{ fontSize: 28 }}>{s.icon}</span>
            <div>
              <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--white)' }}>{s.label}</p>
              <p style={{ fontSize: 12, color: 'var(--muted)' }}>{s.handle}</p>
            </div>
            <span style={{ marginLeft: 'auto', color: 'var(--muted)', fontSize: 16 }}>→</span>
          </a>
        ))}
      </div>

      <p className="section-label">MÉTODOS DE PAGO</p>
      <div className="card" style={{ marginBottom: 24 }}>
        {payments.map((p, i) => (
          <div key={i}>
            {i > 0 && <div className="divider" />}
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ fontSize: 22 }}>{p.icon}</span>
              <div>
                <p style={{ fontSize: 13, fontWeight: 700 }}>{p.label}</p>
                <p style={{ fontSize: 12, color: 'var(--muted)' }}>{p.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {isPushSupported() && (
        <>
          <p className="section-label">NOTIFICACIONES</p>
          <div style={{ marginBottom: 24 }}>
            {pushActive ? (
              <div style={{
                background: 'rgba(0,196,140,0.08)', border: '1px solid rgba(0,196,140,0.25)',
                borderRadius: 14, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12,
              }}>
                <span style={{ fontSize: 22 }}>🔔</span>
                <p style={{ fontSize: 13, fontWeight: 700, color: 'var(--success)' }}>Notificaciones activadas</p>
              </div>
            ) : (
              <button onClick={handleActivatePush} disabled={activatingPush} style={{
                width: '100%', background: 'rgba(255,107,0,0.1)', border: '1px solid rgba(255,107,0,0.3)',
                borderRadius: 14, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 14,
                opacity: activatingPush ? 0.6 : 1,
              }}>
                <span style={{ fontSize: 24 }}>🔔</span>
                <div style={{ textAlign: 'left' }}>
                  <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--orange)' }}>
                    {activatingPush ? 'Activando...' : 'Activar notificaciones'}
                  </p>
                  <p style={{ fontSize: 12, color: 'var(--muted)' }}>Entérate al instante de tus CLICKs y promociones</p>
                </div>
              </button>
            )}
          </div>
        </>
      )}

      <p className="section-label">APARIENCIA</p>
      <div style={{ marginBottom: 24 }}>
        <ThemeSwitcher />
      </div>

      {isAdmin && (
        <button onClick={() => setShowAdmin(true)} style={{
          width: '100%', background: 'rgba(255,107,0,0.1)',
          border: '1px solid rgba(255,107,0,0.3)', borderRadius: 14,
          padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24,
        }}>
          <span style={{ fontSize: 24 }}>⚙️</span>
          <div style={{ textAlign: 'left' }}>
            <p style={{ fontSize: 14, fontWeight: 700, color: 'var(--orange)' }}>Panel de Administrador</p>
            <p style={{ fontSize: 12, color: 'var(--muted)' }}>Gestión de usuarios y tasas</p>
          </div>
        </button>
      )}

      {showAdmin && (
        <AdminPanel
          key={adminDeepLink?.key || 'admin'}
          onClose={() => setShowAdmin(false)}
          initialTab={adminDeepLink?.tab}
          initialSub={adminDeepLink?.sub}
        />
      )}
    </div>
  );
}
